<template>
  <div class="container-form">
    <header-component :title="translate.form.headerTitle" />
    <main>
      <p>{{ translate.form.formTitle }}</p>
      <div class="card">
        <b-form @submit.stop.prevent="onSubmit" v-if="show">
          <b-row>
            <!-- CNPJ -->
            <b-col md="4">
              <b-form-group
                id="input-group-cnpj"
                :label="translate.form.cnpj"
                :invalid-feedback="invalidFeedbackCNPJ"
              >
                <input-cnpj
                  :model.sync="model.cnpj"
                  :placeholder="translate.form.cnpj_placeholder"
                  :state="validateState('cnpj')"
                  :updateCompanyData="updateCompanyData"
                />
              </b-form-group>
            </b-col>

            <!-- Razão Social -->
            <b-col md="4">
              <b-form-group
                id="input-name-group"
                :label="translate.form.name"
                :invalid-feedback="translate.form.invalid_feedback"
              >
                <b-form-input
                  id="input-name"
                  v-model="model.name"
                  type="text"
                  :placeholder="translate.form.name_placeholder"
                  :state="validateState('name')"
                />
              </b-form-group>
            </b-col>

            <!-- Responsável -->
            <b-col md="4">
              <b-form-group
                id="input-group-responsible"
                :label="translate.form.responsible"
                :invalid-feedback="translate.form.invalid_feedback"
              >
                <b-form-input
                  id="input-responsible"
                  v-model="model.responsible"
                  :placeholder="translate.form.responsible_placeholder"
                  :state="validateState('responsible')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>          
            <!-- companyType -->
            <b-col lg="4" md="6">
              <b-form-group
                id="input-group-companyType"
                :label="translate.form.companyType"
                :invalid-feedback="'*Campo Obrigatório'"
                label-for="input-companyType"
              >
                <b-form-select
                  id="input-companyType"
                  v-model="model.companyType"
                  :state="validateState('companyType')"
                  style="font-size: 12px"
                >
                  <option :value="null">{{ translate.optionsTexts.defaultOption }}</option>
                  <option
                    v-for="(option, index) in translate.optionsTexts.companyType" 
                    :key="option"
                    :value="translatePt.optionsTexts.companyType[index]"
                  >
                    {{ option }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>

            <!-- monthlyRevenueAverage -->
            <b-col lg="4" md="6">
              <b-form-group
                id="input-group-monthlyRevenueAverage"
                :label="translate.form.monthlyRevenueAverage"
                :invalid-feedback="'*Campo Obrigatório'"
                label-for="input-monthlyRevenueAverage"
              >
                <b-form-select
                  id="input-monthlyRevenueAverage"
                  v-model="model.monthlyRevenueAverage"
                  :state="validateState('monthlyRevenueAverage')"
                  style="font-size: 12px"
                >
                  <option :value="null">{{ translate.optionsTexts.defaultOption }}</option>
                  <option
                    v-for="(option, index) in translate.optionsTexts.monthlyRevenue" 
                    :key="option"
                    :value="translatePt.optionsTexts.monthlyRevenue[index]"
                  >
                    {{ option }}
                  </option>
                </b-form-select> 
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Segmentos -->
          <check-box
            :label="translate.form.segments"
            :id="'segments'"
            :model.sync="model.segment"
            isColumn="activated"
            :state="validateState('segment')"
            :invalidFeedback="translate.form.invalid_feedback"
          >
            <b-form-checkbox
              v-for="(option, index) in translate.optionsTexts.segments"
              :key="option"
              :value="translatePt.optionsTexts.segments[index]"
            >
              {{ option }}
            </b-form-checkbox>
          </check-box>

          <b-row>
            <!-- CEP -->
            <b-col md="4">
              <b-form-group
                id="input-group-1"
                :label="translate.form.zipcode"
                label-for="input-1"
              >
                <input-cep
                  :model.sync="model.zipcode"
                  :placeholder="translate.form.zipcode_placeholder"
                  :state="validateState('zipcode')"
                  :updateAddress="updateAddress"
                />
                <b-form-invalid-feedback id="input-1-live-feedback">
                  {{ translate.form.invalid_feedback }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Cidade -->
            <b-col md="4">
              <b-form-group
                id="input-group-city"
                :label="translate.form.city"
                :invalid-feedback="translate.form.invalid_feedback"
              >
                <b-form-input
                  id="input-city"
                  v-model="model.city"
                  :placeholder="translate.form.city_placeholder"
                  :state="validateState('city')"
                />
              </b-form-group>
            </b-col>

            <!-- Estado -->
            <b-col md="4">
              <b-form-group
                id="input-group-state"
                label="UF"
                :invalid-feedback="translate.form.invalid_feedback"
              >
                <select-state
                  :model.sync="model.state"
                  :validate="validateState('state')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <!-- E-mail -->
            <b-col md="4">
              <b-form-group
                id="input-group-email"
                :label="translate.form.email"
                :invalid-feedback="translate.form.invalid_feedback"
              >
                <b-form-input
                  id="input-email"
                  v-model="model.email"
                  type="email"
                  :placeholder="translate.form.email_placeholder"
                  :state="validateState('email')"
                />
              </b-form-group>
            </b-col>

            <!-- WhatsApp -->
            <b-col md="4">
              <b-form-group
                id="input-group-whatsApp"
                :label="translate.form.phone"
                :invalid-feedback="translate.form.invalid_feedback"
              >
                <input-phone
                  :model.sync="model.phone"
                  :placeholder="translate.form.phone_placeholder"
                  :state="validateState('phone')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Quantidade de Kits -->
          <b-row>
            <b-col lg="4" md="6">
              <b-form-group
                id="input-group-kits"
                :label="translate.form.kits"
                :invalid-feedback="'*Campo Obrigatório'"
                label-for="input-kits"
              >
                <b-form-select
                  id="input-kits"
                  v-model="model.kit_quantity"
                  :state="validateState('kit_quantity')"
                  style="font-size: 12px"
                >
                  <option :value="null">{{ translate.optionsTexts.defaultOption }}</option>
                  <option
                    v-for="(option, index) in translate.optionsTexts.kits" 
                    :key="option"
                    :value="translatePt.optionsTexts.kits[index]"
                  >
                    {{ option }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <!-- Campo "Já compra Riffel?" -->
            <b-col lg="2" md="3">
              <check-box
                :id="'buy-from-checkbox'"
                :label="translate.form.already_buy_from"
                :model.sync="buyFromCheckbox"
                :state="validateState('already_buy_from')"
                :invalidFeedback="translate.form.invalid_feedback"
              >
                <b-form-checkbox
                  v-for="(option, index) in translate.optionsTexts.buyFrom"
                  :key="option"
                  :value="translatePt.optionsTexts.buyFrom[index]"
                  @change="buyFromOnChange"
                >
                  {{ option }}
                </b-form-checkbox>
              </check-box>
            </b-col>
            <!-- Campo "De quem?" -->
            <b-col lg="4" md="6" v-if="buyFromCheckbox.includes('Sim')">
              <b-form-group
                :label="translate.form.buy_from"
                :invalid-feedback="translate.form.invalid_feedback"
              >
                <b-form-input
                  v-model="model.buy_from"
                  :state="validateState('buy_from')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Produtos -->
          <check-box
            :label="translate.form.products"
            :id="'products'"
            :model.sync="model.product_interest"
            isColumn="activated"
            :state="validateState('product_interest')"
            :invalidFeedback="translate.form.invalid_feedback"
          >
            <b-form-checkbox
              v-for="(option, index) in translate.optionsTexts.products"
              :key="option"
              :value="translatePt.optionsTexts.products[index]"
            >
              {{ option }}
            </b-form-checkbox>
          </check-box>

          <!-- Canal de Atendimento -->
          <check-box
            :label="translate.form.services"
            :id="'services'"
            :model.sync="model.contact_by"
            :state="validateState('contact_by')"
            :invalidFeedback="translate.form.invalid_feedback"
          >
            <b-form-checkbox
              v-for="(option, index) in translate.optionsTexts.services"
              :key="option"
              :value="translatePt.optionsTexts.services[index]"
            >
              {{ option }}
            </b-form-checkbox>
          </check-box>

          <b-col
            md="12"
            class="d-flex justify-content-center align-items-center"
          >
            <b-button type="submit" variant="primary" :disabled="loading">
              {{ translate.form.button }}
              <b-spinner small type="border" v-if="loading" class="ml-2" />
            </b-button>
          </b-col>
        </b-form>
      </div>
    </main>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from 'vuelidate';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { isCNPJ } from 'validation-br';

import { getCompanyAgeCategory } from '@/utils';
import HeaderComponent from './Header.vue';
import CheckBox from '@/shared/CheckBox.vue';
import InputPhone from '@/shared/InputPhone.vue';
import SelectState from '@/shared/SelectState.vue';
import InputCep from '@/shared/InputCep.vue';
import InputCnpj from '@/shared/InputCnpj.vue';
import LeadService from '../service/lead';
import { lead } from './mockup';
import { pt } from "@/lang";

export default {
  name: 'form-register',
  components: {
    HeaderComponent,
    CheckBox,
    InputPhone,
    SelectState,
    InputCep,
    InputCnpj,
  },
  mixins: [validationMixin],
  data() {
    return {
      translatePt: pt,
      model: { ...lead },
      buyFromCheckbox: [],
      show: true,
      loading: false,
    };
  },
  validations: {
    model: {
      name: { required },
      cnpj: { required, isValidCNPJ: isCNPJ },
      city: { required },
      email: { required },
      responsible: { required },
      state: { required },
      phone: { required },
      country: { required },
      zipcode: { required },
      product_interest: { required },
      kit_quantity: { required },
      contact_by: { required },
      companyType: { required },
      monthlyRevenueAverage: { required },
      segment: { required },
      already_buy_from: {
        required: requiredIf(function () {
          return this.buyFromCheckbox.length === 0;
        }),
      },
      buy_from: {
        required: requiredIf(function () {
          return this.buyFromCheckbox.includes('Sim');
        }),
      },
    },
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
    invalidFeedbackCNPJ() {
      const isValid = !this.$v.model.cnpj.isValidCNPJ;
      return isValid && this.model.cnpj
        ? this.translate.invalid_feedback_cnpj
        : this.translate.invalid_feedback;
    },
  },
  methods: {
    ...mapActions([
      'setResellers',
    ]),
    onSubmit() {
      this.loading = true;
      this.$v.model.$touch();
      if (this.$v.model.$anyError) {
        this.loading = false;
        return;
      }

      LeadService.save(this.model)
        .then(response => {
          this.setResellers(response.lead.resellers)
          this.$router.push({
            name: 'result',
            query: { businessName: this.model.name, type: response.type },
          });
        })
        .catch(error => {
          console.log('error', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateCompanyData(data){
      this.model.name = data.razao_social;
      this.model.zipcode = data.cep;
      this.model.city = data.municipio;
      this.model.state = data.uf;
      this.model.companyAge = getCompanyAgeCategory(data.data_inicio_atividade);
    },
    updateAddress({ city, state }) {
      this.model.city = city;
      this.model.state = state;
    },
    buyFromOnChange() {
      this.model.buy_from = null;

      if (this.buyFromCheckbox.length > 1) {
        this.buyFromCheckbox = [
          this.buyFromCheckbox[this.buyFromCheckbox.length - 1],
        ];
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.model[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-control {
  font-size: 12px;
}

legend {
  font-size: 12px;
}

.form-control.is-valid {
  border-color: #ced4da;
  background-image: none;
  box-shadow: none;
}

.form-control.is-valid:focus {
  border-color: #000;
  box-shadow: none;
}

.form-control.is-invalid:focus {
  box-shadow: none;
}

.custom-select.is-valid {
  border-color: #ced4da;
  background: #fff
    url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e')
    right 0.75rem center/8px 10px no-repeat;
}

.custom-select.is-valid:focus {
  border-color: #000;
  box-shadow: none;
}

.row {
  font-size: 12px;
}

input:focus {
  border-color: #000;
  box-shadow: none;
}

select:focus {
  border-color: #000;
  box-shadow: none;
}

.custom-select.is-valid:focus {
  border-color: #000;
  box-shadow: none;
}

.container-form {
  main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #000;
    max-width: 1140px;
    width: 90%;
    margin-inline: auto;
    margin-top: 60px;

    p {
      margin-bottom: 16px;
      text-align: center;
    }

    .card {
      padding: 2rem;
      width: 100%;
      border: 1px solid #dfe0e0;
      border-radius: 5px;
      background: #fff;
      margin-bottom: 24px;
      .title {
        position: relative;
        h2 {
          font-weight: normal;
        }
        p {
          margin: 35px 0;
          font-size: 16px;
        }
      }
      legend {
        font-size: 12px;
      }

      button {
        color: #011640;
        background-color: #66ded0;
        background-image: linear-gradient(180deg, #66ded0 0%, #5bb6ff 100%);
        border-width: 0px;
        border-radius: 20px;
        padding: 12px 20px 12px 20px;
        font-size: 15px;
        text-transform: uppercase;
        font-weight: 600;
      }
    }
  }

  button:disabled,
  select:disabled {
    cursor: not-allowed !important;
  }
}
</style>
